//////////////////////////////////////////////////////////
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE COMO CHECKBOX NA PÁGINA DE LOGIN            //   
//                                                      //   
//  FUNCIONALIDADE: INDICAR LOGIN COMO FRANQUEADO       //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/pages/login.js                                     //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import Logo from './header/logo';
import Voltar from './header/voltar';

import '../assets/css/local/header.css';

function Franqueado() {
    function ativar_modo_lojista(){  // FUNÇÃO PARA REALIZAR O LOGIN COMO FRANQUEADO
        // FUNÇÃO CHAMADA NO SELECIONAR (OU DESSELECIONAR) DO CHECKBOX 'Franqueado'

        if(document.getElementById('titulo').innerText !== 'CNPJ'){  // CASO O CHECKBOX SEJA SELECIONADO
            document.getElementById('titulo').innerText = 'CNPJ'  // ALTERAR A FORMA DE LOGIN PARA CNPJ
            document.getElementById('btn_criar_usuario').classList.add('d-none')  // E SUMIR O CARD E BOTÃO DE CRIAR USUÁRIO
            document.getElementById('form_criar_usuario').classList.add('d-none')
        }  
        else{  // CASO O CHECKBOX SEJA DESSELECIONADO
            document.getElementById('titulo').innerText = 'E-mail/CPF/Telefone Celular'  // ALTERAR A FORMA DE LOGIN PARA CPF, TELEFONE OU E-MAIL  
            document.getElementById('btn_criar_usuario').classList.remove('d-none')  // APARECER O CARD E BOTÃO DE CRIAR USUÁRIO
            document.getElementById('form_criar_usuario').classList.remove('d-none')
        }
    }

    // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
      // 'Logo' -> FOTO DO LOGO DA IMAGINARIUM
      // 'Voltar' -> BOTÃO QUE REDIRECIONA PARA A PÁGINA HOME
      
    return (
        <div>
            <div className="pb-3 border-header header-top">
                <div className="row col col-12 m-0 pt-3 px-0">   
                    <div class="d-none d-md-block col-4">
                        <Logo />
                    </div>   
                    <div class='col-md-4 col-6'>
                        <Voltar />
                    </div>    
                    <div class="justify-content-end col-md-4 col-6">
                        <p class="m-0 p-0 verde montserrat fonte-x-large pull-right">Franqueado
                        <input type="checkbox" class="ml-2" onClick={ativar_modo_lojista}></input></p>
                    </div>
                </div>
            </div>      
        </div>
    );
  }

  export default Franqueado;
  